/* import __COLOCATED_TEMPLATE__ from './seller-profile-block-freelancer-item.hbs'; */
import Component from '@ember/component';

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'li',
  classNames: ['SH-c-seller-profile-block-freelancer-item', 'margin-top-16px'],

  /**
   * @type {BlockUserEvent|null}
   */
  blockUserEvent: null,
});
